<!-- a11y: prevent default browser submit on Enter / mobile "Search" key; see search-station-form for full rationale. -->
<form
  [formGroup]="routePlannerForm"
  class="route-planner-form h-full"
  (ngSubmit)="submitRoutePlannerForm()"
>
  <div class="flex flex-col h-full w-full gap-4">
    <div class="flex flex-col gap-4 bg-white rounded-b-xl p-4 shadow-lg">
      <mot-autocomplete
        formControlName="origin"
        [displayErrors]="false"
        appearance="fill"
        inputIcon="arrow-down-arrow-up"
        inputIconClass="cursor-pointer text-2xl text-white ml-2 p-1 bg-primary rounded-3xl"
        [label]="fromCityText"
        (onIconClick)="switchLocations()"
        [iconButtonAriaLabel]="switchLocationsText"
        fieldClass="bg-transparent w-full !text-default"
        [displayFn]="routePlanningService.displayCityName"
        [options]="originCities$"
        
      >
      <ng-template #customOption let-option>
          <div class="flex items-center gap-1">
            <ng-icon name="location-dot" class="text-2xl"></ng-icon>
            <span>{{ option.value.cityName }}</span>
          </div>

      </ng-template>
    </mot-autocomplete>

      <mot-autocomplete
        formControlName="destination"
        [displayErrors]="false"
        appearance="fill"
        [label]="toCityText"
        fieldClass="bg-transparent w-full !text-default"
        [displayFn]="routePlanningService.displayCityName"
        [options]="destinationCities$"
       
      >
      <ng-template #customOption let-option>
        <div class="flex items-center gap-1">
          <ng-icon name="location-dot" class="text-2xl"></ng-icon>
          <span>{{ option.value.cityName }}</span>
        </div>
      </ng-template>
    </mot-autocomplete>
    </div>

    <mot-date-time-picking-form class="px-4"
      [timeOptFormControl]="getFormControl('timeOpt')"
      [arrivalFormGroup]="getNestedGroup('arrival')"
      [departureFormGroup]="getNestedGroup('departure')"
    />
  </div>
</form>
